import React, { useState } from "react";
import { useQuery } from "react-query";
import { Input, Button } from "../components";

export default function Calculator() {
  const { isLoading } = useQuery(
    "repoData",
    () =>
      fetch(
        "https://api.zapper.fi/v1/farms/masterchef?network=ethereum&api_key=96e0cc51-a62e-42ca-acee-910ea7d2a241"
      ).then((res) => res.json()),
    {
      onSuccess: (res) => {
        console.log({ res });
        console.log("ALUSD Pool APY", res[0].yearlyROI);
        setALUSD([res[1].yearlyROI]);
      },
      onError: (e) => console.log("error", e)
    }
  );

  const [ALUSD, setALUSD] = useState(0.3);
  const [numOfEvents, setEvents] = useState([1]);
  const [price, setPrice] = useState([40]);
  const [numberOfAttendees, setNumberoOfAttendees] = useState([15000]);

  const [artistCurrent, setArtistCurrent] = useState(0.5);
  const [artistFuture, setArtistFuture] = useState(0.3);
  const [venueBills, setVenueBills] = useState(0.7);

  const [showPercentages, setShowPercentages] = useState(false);

  const ready = numOfEvents && price && numberOfAttendees;

  const revenuePerEvent = numberOfAttendees * price;
  const totalRevenue = revenuePerEvent * numOfEvents;
  const artistUpfrontPayment = totalRevenue * artistCurrent;
  const remainingIncome = totalRevenue * (1 - artistCurrent);
  const venueCurrent = remainingIncome * venueBills;
  const stakeAmount = remainingIncome - venueCurrent;
  const loanAmount = stakeAmount / 2;
  const totalBalance = loanAmount * Math.pow(1 + ALUSD / 12, 12);
  const yearlyEarnings = totalBalance - loanAmount;
  const artistAmount = yearlyEarnings * artistFuture;

  function calculateEarnings(APY = 0.5, duration) {
    // Revenue per event - Attendees * ticket price
    console.log("revenuePerEvent", revenuePerEvent);

    // Step 1 - Calculate total revenue - Revenue per event * number of events
    console.log("totalRevenue", totalRevenue);
    // Step 2 - Artist upfront payment
    console.log("ArtistUpfront", artistUpfrontPayment);
    // Step 3 - Remaining Income
    console.log("remainingIncome", remainingIncome);
    // Step 4 - Venue pays their bills
    console.log("venueCurrent", venueCurrent);
    // Step 5 - Stake remaining income for loan
    console.log("stakeAmount", stakeAmount);
    // Step 6 - Loan Received
    console.log("loanAmount", loanAmount);
    // Step 7/8 - Loan gets put into pool - Loan gets interest
    console.log("totalBalance", totalBalance);
    // Total Yearly Earnings = totalBalance (including interest) - initial investment
    console.log("yearlyEarnings", yearlyEarnings);

    // Step 9 - Artist receives 30% of total amount
    console.log("ArtistAmount", artistAmount);

    // Fixed to two decimal places e.g. £10.12
    if (duration === "month") {
      return (artistAmount / 12).toFixed(2);
    } else if (duration === "10years") {
      return (artistAmount * 10).toFixed(2);
    } else {
      return artistAmount.toFixed(2);
    }
  }

  return (
    <div className="bg-gradient-to-br from-blue-500 to-blue-400 h-screen flex flex-col justify-between p-10">
      {showPercentages && (
        <div>
          <div className="grid grid-cols-3">
            <div className="bg-white m-2 p-2 rounded-md flex flex-col">
              <label>Artist Current Percentage:</label>
              <input
                className="border"
                value={artistCurrent}
                onChange={(e) => setArtistCurrent(e.target.value)}
              />
            </div>
            <div className="bg-white m-2 p-2 rounded-md flex flex-col">
              <label>Venue Bills Percentage:</label>
              <input
                className="border"
                value={venueBills}
                onChange={(e) => setVenueBills(e.target.value)}
              />
            </div>
            <div className="bg-white m-2 p-2 rounded-md flex flex-col">
              <label>Artist Current Percentage:</label>
              <input
                className="border"
                value={artistFuture}
                onChange={(e) => setArtistFuture(e.target.value)}
              />
            </div>
          </div>
          <div className="bg-white rounded-md m-2 p-2 shadow-md">
            <div className="text-center">£{totalRevenue}</div>
            <div className="grid grid-cols-2 border justify-center">
              <div className="text-center">£{artistUpfrontPayment}</div>
              <div className="text-center bg-red-500">
                £{totalRevenue - artistUpfrontPayment}
              </div>
            </div>
            <div className="grid grid-cols-2 border justify-center">
              <div className="text-center bg-red-500">
                £{totalRevenue - artistUpfrontPayment}
              </div>
              <div className="text-center">£{artistUpfrontPayment}</div>
            </div>
            <div className="grid grid-cols-2 border">
              <div className="grid grid-cols-3">
                <div className="text-center border">£{stakeAmount}</div>
                <div className="text-center border col-span-2">
                  £{venueCurrent}
                </div>
              </div>
              <div></div>
            </div>
            <div className="grid grid-cols-2 border">
              <div className="grid grid-cols-2">
                <div className="grid grid-cols-3">
                  <div className="text-center bg-red-500">£{loanAmount}</div>
                  <div className="text-center">.</div>
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div className="grid grid-cols-2 border">
              <div className="grid grid-cols-2">
                <div className="grid grid-cols-3">
                  <div className="text-center bg-gray-500">£{loanAmount}</div>
                  <div className="text-center"></div>
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div className="grid grid-cols-2 border">
              <div className="grid grid-cols-4">
                <div className="grid grid-cols-3">
                  <div className="text-center bg-red-500">
                    £{yearlyEarnings.toFixed(2)}
                  </div>
                  <div className="text-center"></div>
                  <div className="text-center"></div>
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div className="grid grid-cols-2 border">
              <div className="grid grid-cols-2">
                <div className="grid grid-cols-10">
                  <div className="text-center bg-green-500">
                    £{artistAmount.toFixed(2)}
                  </div>
                  <div className="text-center"></div>
                  <div className="text-center"></div>
                </div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <div className="bg-white flex flex-col m-2 rounded-md p-2">
            <label className="font-semibold">Artist Upfront Percentage</label>
            <input
              className="border shadow-md my-2 p-2"
              onChange={(e) => setArtistCurrent(e.target.value)}
              value={artistCurrent}
            />
            <span className="text-xs">
              Artist upfront percentage of total event revenue.
            </span>
          </div>
          <div className="bg-white flex flex-col m-2 rounded-md p-2">
            <label className="font-semibold">Venue Bills Percentage</label>
            <input
              className="border shadow-md my-2 p-2"
              onChange={(e) => setVenueBills(e.target.value)}
              value={venueBills}
            />
            <span className="text-xs">
              Percentage of the total event revenue the venue needs to spend on
              bills before adding funds to the platform.
            </span>
          </div>
          <div className="bg-white flex flex-col m-2 rounded-md p-2">
            <label className="font-semibold">
              Yield Farming - Total Interest - Artist Percentage
            </label>
            <input
              className="border shadow-md my-2 p-2"
              onChange={(e) => setArtistFuture(e.target.value)}
              value={artistFuture}
            />
            <span className="text-xs">
              The percentage of the total interest the artist will receive after
              farming.
            </span>
          </div>
        </div> */}

      <div>
        <h1 className="md:text-7xl text-4xl font-bold tracking-tight text-white">
          Lifetime
          <br /> Royalties
          <br /> Calculator.
        </h1>
        <h2 className="md:text-3xl text-1xl font-bold tracking-tight text-white my-2">
          You can start earning lifetime Royalties from the very first gig you
          play at the Chapel.
        </h2>
      </div>
      {ready && (
        <div className="flex mx-auto border flex-col justify-center items-center shadow-2xl bg-white bg-opacity-80 rounded-md sm:p-5 p-2 sm:max-w-md">
          <p className="text-center">
            When you play at the chapel you could earn:
          </p>
          <div className="flex flex-col justify-center items-center">
            <p className="sm:text-5xl text-2xl text-center font-bold">
              {isLoading
                ? "Calculating..."
                : `£${calculateEarnings(ALUSD, "month")}`}
              <span className="text-sm opacity-80"> /month</span>
            </p>

            <p className="sm:text-5xl text-2xl text-center font-bold">
              {isLoading
                ? "Calculating..."
                : `£${calculateEarnings(ALUSD, "year")}`}
              <span className="text-sm opacity-80"> /year</span>
            </p>
            <p className="sm:text-5xl text-2xl text-center font-bold">
              {isLoading
                ? "Calculating..."
                : `£${calculateEarnings(ALUSD, "10years")}`}
              <span className="text-sm opacity-80"> /10 years</span>
            </p>
          </div>
          <p className="text-xs italic opacity-50 font-semibold text-center">
            Figures calculated using realtime yearly ROI of the{" "}
            <a
              style={{ textDecoration: "underline" }}
              href="https://app.alchemix.fi/farms"
            >
              ALCX
            </a>{" "}
            pool.
          </p>
        </div>
      )}
      <div className="flex lg:flex-row flex-col justify-between">
        <Input
          label="How many gigs do you play at a chapel venue per year?"
          value={numOfEvents}
          setValue={setEvents}
          min={0}
          max={10}
        />
        <Input
          label="What is the average ticket price for your gigs(£)?"
          value={price}
          setValue={setPrice}
          min={0}
          max={40}
        />
        <Input
          label="What is the average number of attendees at your gigs?"
          value={numberOfAttendees}
          setValue={setNumberoOfAttendees}
          min={0}
          max={30000}
        />
      </div>
      {/* <Button onClick={() => setShowPercentages((s) => !s)}>
        Toggle Artist/Venue splits
      </Button>
      <div className="flex">
        <p>current APY: {ALUSD * 100}%</p>
      </div> */}
    </div>
  );
}
